/* eslint-disable react/react-in-jsx-scope */

import { Box, makeStyles } from "@material-ui/core";
import React from "react";
export type BadgeTypes =
  | "blue"
  | "purple"
  | "orange"
  | "yellow"
  | "green"
  | "red"
  | "grey"
  | "teal"
  | "brown";

interface BadgeProps {
  variant?: BadgeTypes;
  label?: string;
}

export const variantBackgroundColors: Record<BadgeTypes, string> = {
  blue: "#DBEAFE",
  purple: "#F3E8FF",
  orange: "#FFEDD4",
  yellow: "#FEF3C6",
  green: "#EDFFED",
  red: "#FEF2F2",
  grey: "#F1F5F9",
  teal: "#CCFBF1",
  brown: "#EFEBE9",
};

export const variantBorderColors: Record<BadgeTypes, string> = {
  blue: "#BEDBFF",
  purple: "#E9D4FF",
  orange: "#FFD6A8",
  yellow: "#FEE685",
  green: "#00A63E",
  red: "#FECACA",
  grey: "#E2E8F0",
  teal: "#5EEAD4",
  brown: "#BCAAA4",
};

export const variantTextColors: Record<BadgeTypes, string> = {
  blue: "#1E40AF",
  purple: "#8200DB",
  orange: "#CA3500",
  yellow: "#BB4D00",
  green: "#00A63E",
  red: "#B91C1C",
  grey: "#64748B",
  teal: "#0F766E",
  brown: "#5D4037",
};

export const useBadgeStyles = makeStyles(() => ({
  container: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    whiteSpace: "nowrap",
    flexShrink: 0,
    padding: "5px 13px",
    borderRadius: "60px",
    color: "#fff",
    fontWeight: 600,
    fontSize: "14px",
  },
}));

const Badge = ({ variant = "blue", label }: BadgeProps) => {
  const badgeStyles = useBadgeStyles();
  return (
    <Box
      className={badgeStyles.container}
      style={{
        backgroundColor: variantBackgroundColors[variant],
        border: `1px solid ${variantBorderColors[variant]}`,
      }}
    >
      <span style={{ color: variantTextColors[variant], textAlign: "center" }}>{label}</span>
    </Box>
  );
};

export default Badge;
